import React, { useState } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Plus, Trash, CalendarBlank } from "@phosphor-icons/react";
import WhyThisMatters from "../WhyThisMatters";

const inputCls = "rounded-none border-slate-300 focus:border-slate-900 focus:ring-1 focus:ring-slate-900";

export default function TimelineTab({ caseData, save }) {
  const [timeline, setTimeline] = useState(caseData.timeline || []);

  const addEvent = () => {
    setTimeline([
      ...timeline,
      { id: crypto.randomUUID(), date: "", title: "", description: "" },
    ]);
  };
  const updateEvent = (id, key, val) => {
    setTimeline(timeline.map((e) => (e.id === id ? { ...e, [key]: val } : e)));
  };
  const removeEvent = (id) => setTimeline(timeline.filter((e) => e.id !== id));

  const handleSave = () => {
    const sorted = [...timeline].sort((a, b) => (a.date || "").localeCompare(b.date || ""));
    save({ timeline: sorted });
    setTimeline(sorted);
  };

  const sortedView = [...timeline].sort((a, b) => (a.date || "").localeCompare(b.date || ""));

  return (
    <div className="space-y-8">
      <div className="flex items-baseline justify-between">
        <div>
          <h2 className="font-serif-display text-3xl text-slate-900">Timeline of Events</h2>
          <p className="text-slate-600 mt-1">Add events chronologically. They will appear sorted by date and ground your factual allegations.</p>
        </div>
        <span className="label-tiny">Step 3 of 8</span>
      </div>

      <Button type="button" onClick={addEvent} data-testid="add-event-btn" className="rounded-none bg-slate-900 hover:bg-slate-800 text-white">
        <Plus className="w-4 h-4 mr-2" /> Add event
      </Button>

      {sortedView.length === 0 ? (
        <div className="border border-dashed border-slate-300 p-10 text-center text-slate-500">
          No timeline events yet.
        </div>
      ) : (
        <div className="relative pl-6 border-l-2 border-slate-200 space-y-6">
          {sortedView.map((e, i) => (
            <div key={e.id} className="relative" data-testid={`timeline-event-${e.id}`}>
              <div className="absolute -left-[31px] top-2 w-4 h-4 bg-white border-2 border-slate-900" />
              <div className="border border-slate-200 p-5 bg-white">
                <div className="flex items-center gap-2 mb-3">
                  <CalendarBlank weight="duotone" className="w-5 h-5 text-slate-700" />
                  <span className="label-tiny">Event {i + 1}</span>
                  <Button type="button" variant="ghost" size="sm" onClick={() => removeEvent(e.id)} className="ml-auto text-red-700 hover:bg-red-50 rounded-none" data-testid={`remove-event-${e.id}`}>
                    <Trash className="w-4 h-4" />
                  </Button>
                </div>
                <div className="grid md:grid-cols-3 gap-3">
                  <Input type="date" value={e.date} onChange={(ev) => updateEvent(e.id, "date", ev.target.value)} className={inputCls} data-testid={`event-date-${e.id}`} />
                  <Input value={e.title} onChange={(ev) => updateEvent(e.id, "title", ev.target.value)} placeholder="Title" className={`${inputCls} md:col-span-2`} data-testid={`event-title-${e.id}`} />
                  <Textarea value={e.description} onChange={(ev) => updateEvent(e.id, "description", ev.target.value)} placeholder="Describe what happened…" className={`${inputCls} md:col-span-3 min-h-[80px]`} data-testid={`event-description-${e.id}`} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="flex justify-end pt-2 border-t border-slate-200 mt-8">
        <Button onClick={handleSave} data-testid="save-timeline-btn" className="rounded-none bg-slate-900 hover:bg-slate-800 text-white">
          Save Timeline
        </Button>
      </div>

      <WhyThisMatters step="timeline" />
    </div>
  );
}
